import DropzoneFiles from "./DropzoneFiles";

export default DropzoneFiles;



// WEBPACK FOOTER //
// ./src/commonComponents/DropzoneFiles/index.js